import React from 'react'
import { RadioOption, InputError, Button, Box } from '@foodsby/nutrient'
import { Textarea } from '../common/reduxForms/Textarea'
import ModalPopup from '../common/ModalPopup'

export const SelfCancelError = ({ selfCancelError }) => (
  <InputError visible={selfCancelError && selfCancelError !== null}>
    {selfCancelError.message || selfCancelError}
  </InputError>
)

export const SuccessMessage = () => (
  <div className="panel">
    <p className="panel-title">Thank you for contacting us.</p>
    <Box mb={3}>
      <p>
        A dedicated Foodsby Team Member will contact you as soon as possible.
      </p>
    </Box>
  </div>
)

export const ErrorMessage = () => (
  <InputError visible={true}>
    Sorry. Something went wrong with your submission. Please try again in a few
    minutes.
  </InputError>
)

export const ConfirmMessage = ({ cancelRejected, confirmingCancel }) => (
  <ModalPopup showCancel={false}>
    <div className="row center-xs successMessage">
      <Box pb={2}>
        <h4>Are you sure that you want to cancel your entire order?</h4>
      </Box>
      <Box pb={4}>
        <p>If you used credits on this order, they will be refunded.</p>
      </Box>
      <div className="row center-xs middle-xs">
        <div className="col-xs-4">
          <Button className="secondary" onClick={cancelRejected}>
            No
          </Button>
        </div>
        <div className="col-xs-4">
          <Button className="primary destructive" onClick={confirmingCancel}>
            Yes, Cancel
          </Button>
        </div>
      </div>
    </div>
  </ModalPopup>
)

const ContactUsLightForm = ({ handleSubmit, reasons, handleChange }) => {
  return (
    <form className="panel-form" onSubmit={handleSubmit}>
      {reasons &&
        reasons.map((reason, i) => (
          <RadioOption
            className="panel-options"
            id={reason.label}
            key={i}
            label={reason.label}
            name="reasonOption"
            onChange={handleChange}
            required
            value={reason.id}
          />
        ))}
      <Textarea
        className="panel-description"
        id="comment"
        label="Comments *"
        maxLength="1000"
        mb={2}
        name="comment"
        onChange={handleChange}
        required
      />
      <Button className="panel-submit" mb={3} type="submit">
        Submit
      </Button>
    </form>
  )
}
export default ContactUsLightForm
